import { Link } from "react-router-dom";
import {
  convertMultipleNewlinesToBR,
  truncateWords,
} from "../exports/functions";
import { marked } from "marked";

const InfoTwo = (props) => {
  const { tilesHeaderData, tilesData } = props;
  const rawDescription1 = tilesData[0]?.description || "";
  const description1 = convertMultipleNewlinesToBR(rawDescription1);
  const rawDescription2 = tilesData[1]?.description || "";
  const description2 = convertMultipleNewlinesToBR(rawDescription2);
  const rawDescription3 = tilesData[2]?.description || "";
  const description3 = convertMultipleNewlinesToBR(rawDescription3);
  const rawDescription4 = tilesData[3]?.description || "";
  const description4 = convertMultipleNewlinesToBR(rawDescription4);
  return (
    <section className="info-two" id="tiles">
      <div className="container">
        <div className="bg-white box-shadow-md rounded-16 p-16">
          <div
            className="flex-align d-inline-flex gap-8 mb-16 w-100 justify-content-center"
            id="tilesheader"
          >
            <span className="text-main-600 text-2xl d-flex">
              <i className="ph-bold ph-book-open" />
            </span>
            <h5 className="text-main-600 mb-0">{tilesHeaderData[0]?.title}</h5>
          </div>
          <div className="row gy-4 justify-content-center">
            <div
              className="col-xl-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration={400}
            >
              <div className="info-two-item animation-item h-100 gap-28 border border-neutral-30 rounded-12 bg-main-three-25">
                <div className="flex-align gap-28">
                  <span className="flex-shrink-0">
                    <img
                      src="assets/images/icons/info-two-icon1.png"
                      className="animate__heartBeat"
                      alt=""
                    />
                  </span>
                  <div>
                    <h4 className="mb-16">{tilesData[0]?.title}</h4>
                    <p
                      className="text-neutral-700"
                      dangerouslySetInnerHTML={{
                        __html: marked(truncateWords(description1, 10)),
                      }}
                    ></p>
                  </div>
                </div>
                <div className="pt-24 border-top border-neutral-50 mt-28 border-dashed border-0">
                  <Link
                    to="/programs"
                    className="flex-align gap-8 text-main-600 transition-1 fw-semibold justify-content-end"
                    tabIndex={0}
                    state={{ section: `tiles${tilesData[0]?.id}` }}
                  >
                    <span className="hover-text-decoration-underline">
                      Read More
                    </span>
                    <i className="ph ph-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-xl-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration={600}
            >
              <div className="info-two-item animation-item h-100 border border-neutral-30 rounded-12 bg-main-two-25">
                <div className="flex-align gap-28">
                  <span className="flex-shrink-0">
                    <img
                      src="assets/images/icons/info-two-icon2.png"
                      className="animate__heartBeat"
                      alt=""
                    />
                  </span>
                  <div>
                    <h4 className="mb-16">{tilesData[1]?.title}</h4>
                    <p
                      className="text-neutral-700"
                      dangerouslySetInnerHTML={{
                        __html: marked(truncateWords(description2, 10)),
                      }}
                    ></p>
                  </div>
                </div>
                <div className="pt-24 border-top border-neutral-50 mt-28 border-dashed border-0">
                  <Link
                    to="/programs"
                    className="flex-align gap-8 text-main-600 transition-1 fw-semibold justify-content-end"
                    tabIndex={0}
                    state={{ section: `tiles${tilesData[1]?.id}` }}
                  >
                    <span className="hover-text-decoration-underline">
                      Read More
                    </span>
                    <i className="ph ph-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-xl-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration={800}
            >
              <div className="info-two-item animation-item h-100 border border-neutral-30 rounded-12 bg-main-two-25">
                <div className="flex-align gap-28">
                  <span className="flex-shrink-0">
                    <img
                      src="assets/images/icons/info-two-icon3.png"
                      className="animate__heartBeat"
                      alt=""
                    />
                  </span>
                  <div>
                    <h4 className="mb-16">{tilesData[2]?.title}</h4>
                    <p
                      className="text-neutral-700"
                      dangerouslySetInnerHTML={{
                        __html: marked(truncateWords(description3, 10)),
                      }}
                    ></p>
                  </div>
                </div>
                <div className="pt-24 border-top border-neutral-50 mt-28 border-dashed border-0">
                  <Link
                    to="/programs"
                    className="flex-align gap-8 text-main-600 transition-1 fw-semibold justify-content-end"
                    tabIndex={0}
                    state={{ section: `tiles${tilesData[2]?.id}` }}
                  >
                    <span className="hover-text-decoration-underline">
                      Read More
                    </span>
                    <i className="ph ph-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-xl-6 col-sm-6"
              data-aos="fade-up"
              data-aos-duration={800}
            >
              <div className="info-two-item animation-item h-100 border border-neutral-30 rounded-12 bg-main-three-25">
                <div className="flex-align gap-28">
                  <span className="flex-shrink-0">
                    <img
                      src="assets\images\icons\features-two-icon1.png"
                      className="animate__heartBeat"
                      alt=""
                    />
                  </span>
                  <div>
                    <h4 className="mb-16">{tilesData[3]?.title}</h4>
                    <p
                      className="text-neutral-700"
                      dangerouslySetInnerHTML={{
                        __html: marked(truncateWords(description4, 10)),
                      }}
                    ></p>
                  </div>
                </div>
                <div className="pt-24 border-top border-neutral-50 mt-28 border-dashed border-0">
                  <Link
                    to="/programs"
                    className="flex-align gap-8 text-main-600 transition-1 fw-semibold justify-content-end"
                    tabIndex={0}
                    state={{ section: `tiles${tilesData[3]?.id}` }}
                  >
                    <span className="hover-text-decoration-underline">
                      Read More
                    </span>
                    <i className="ph ph-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoTwo;
